import { Component } from '@verndale/core';

class LeavingPopup extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $modal: this.$el,
      $closeButton: this.$el.find('.leaving-popup__card__close-button'),
      $linkButton: this.$el.find('.leaving-popup__card__link-button'),
      $linkUrl: this.$el.find('.leaving-popup__card__link-url'),
      $anchors: $('a:not(.leaving-popup__card__link-button)'),
      body: document.getElementsByTagName('body')[0]
    };
    this.removeActiveState();
    this.setupIcons(this.dom.$anchors);
  }

  isAnchorExternal(anchor) {
    const dontOpenPopup = anchor.dataset.dontOpenPopup;
    return !(
      dontOpenPopup ||
      anchor.hostname === window.location.hostname ||
      anchor.hostname === 'rtw.oneworld.com' ||
      anchor.hostname === 'assets.ctfassets.net' ||
      anchor.hostname === 'flights.oneworld.com'
    );
  }

  setupIcons(anchors) {
    anchors.each((_, anchor) => {
      if (this.isAnchorExternal(anchor)) {
        anchor.classList.add('external-anchor-icon');
      }
    });
  }

  addListeners() {
    this.dom.$closeButton.on('click', e => this.closePopup(e));
    this.dom.$anchors.on('click', e => this.openPopup(e));
    this.dom.$linkButton.on('click', e => this.closePopup(e));
    this.$el.on('trigger:open', (e, param) => this.openPopup(param));
    window.addEventListener('links-watch', () => {
      const dynamicAnchors = $('a:not(.leaving-popup__card__link-button)');
      dynamicAnchors.on('click', e => this.openPopup(e));
      this.setupIcons(dynamicAnchors);
    });
  }

  cleanAttrs() {
    this.dom.$linkUrl.text('');
    this.dom.$linkButton.attr({ target: '', href: '' });
  }

  openPopup(e) {
    const anchor = e.currentTarget;
    if (!this.isAnchorExternal(anchor)) return;
    const url = anchor.getAttribute('href');
    const existOnWhiteList = Boolean(
      window.ONEWORLD_LEAVING_WHITELIST.find(
        whiteListURL => whiteListURL.toLowerCase() === url.toLocaleLowerCase()
      )
    );
    if (existOnWhiteList) return;
    this.cleanAttrs();
    e.preventDefault();
    if (!url) return;
    this.dom.body.style.overflow = 'hidden';
    this.dom.body.classList.add('leaving-popup-active');
    const target = anchor.getAttribute('target');
    this.dom.$linkUrl.text(url);
    this.dom.$linkButton.attr({ target, href: url });
    this.dom.$modal.addClass('active');
  }

  closePopup(e) {
    e.preventDefault();
    const target = e.currentTarget;
    const href = target.getAttribute('href');
    this.dom.$modal.removeClass('active');
    this.dom.body.style.overflow = 'visible';
    this.dom.body.classList.remove('leaving-popup-active');
    if (href) {
      window.location.href = href;
    }
  }
  removeActiveState(){
    this.dom.$modal.removeClass('active');
    this.dom.body.removeAttribute('style');
    this.dom.body.classList.remove('leaving-popup-active');
  }
}

export default LeavingPopup;
